import { MEDIA_EXTENSION_MAP, MediaCategoryType, MediaExtension } from '../types/mediaTypes';

type Props = {
  url: string;
};

export const getMediaType = ({ url }: Props): MediaCategoryType => {
  const ext = url.split('.').pop()?.toLowerCase();

  return ext ? (MEDIA_EXTENSION_MAP[ext as MediaExtension] ?? 'unknown') : 'unknown';
};
